import { HttpStatusCodeEnum } from '../../../@shared/domain/enums/HttpStatusCode.enum'
import { StorageUsage } from '../../domain/entities/StorageUsage'
import { IStorageRepository } from '../../domain/repositories/IStorage.repository'
import { StorageUsageSchema } from '../schemas/StorageUsage.schema'
import { StorageClient } from './StorageClient.abstract'

export class StorageRepositoryApiAdapter implements IStorageRepository {
	private _endpoint = '/v2/ImagemParaProcessamento'

	constructor(private _httpClient: StorageClient) {}

	async getStorageUsage(): Promise<StorageUsage> {
		const response = await this._httpClient.get(`${this._endpoint}/recuperar-status-armazenamento`)

		if (response.status !== HttpStatusCodeEnum.Ok) return new StorageUsage(0, 0, 0)

		return StorageUsageSchema.parse(response.data)
	}

	async requestStorageIncrease(): Promise<void> {
		const response = await this._httpClient.post(
			`${this._endpoint}/requisitar-aumento-espaco-armazenamento`,
		)

		if (response.status !== HttpStatusCodeEnum.Ok) {
			throw new Error(
				'Não foi possível solicitar aumento de armazenamento. Por favor, tente novamente',
			)
		}
	}
}
